<template>
<div id="app">
    <Nav />
    <transition name="fade" mode="out-in">
        <router-view />
    </transition>
    <WebCart v-if="this.$route.name !=='Home'"/>
<!--
  <SocialMedia v-if="this.$route.name !=='Explore'"/>
-->
  <SocialMedia v-show="!isGate"/>

</div>
</template>

<script>
import Nav from "./components/Nav";
import WebCart from "./components/WebCart";


import {
    STORAGE_KEY
} from "./store";
import SocialMedia from "@/components/SocialMedia";

export default {
    name: 'App',
    components: {
        Nav,
        WebCart,
        SocialMedia
    },
    data() {
        return {
          isGate: false
        }
    },

  beforeUpdate() {
      if (this.$route.name === 'Home' || this.$route.name === 'About' || this.$route.name === 'Contribute' || this.$route.name === 'Contact' || this.$route.name === 'Credits' || this.$route.name === 'Privacy'){
        this.isGate = false
      }
      else {
        this.isGate = true

      }
  },

    created() {
        let collectedLocal = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        if (collectedLocal.length > 0) {
            for (let i = 0; i < collectedLocal.length; i++) {
                this.$store.dispatch("addItem", collectedLocal[i]);
            }
        } else {
            //console.log('Store empty')
        }

        let discoveredLocal = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        if (discoveredLocal.length > 0) {
            for (let i = 0; i < discoveredLocal.length; i++) {
                this.$store.dispatch("discoverItem", discoveredLocal[i]);
            }
        } else {
            //console.log('None discovered')
        }


    },


}
</script>

<style>
@font-face {
    font-family: 'Tauri';
    src: url('/fonts/Tauri-Regular.woff') format('woff'), url('/fonts/Tauri-Regular.ttf') format('ttf');
}

@font-face {
    font-family: 'ElaineSans';
    src: url('/fonts/ElaineSans-Regular.woff') format('woff'), url('/fonts/ElaineSans-Regular.ttf') format('ttf');
}

@font-face {
    font-family: 'ElaineSans-Bold';
    src: url('/fonts/ElaineSans-SemiBold.woff') format('woff'), url('/fonts/ElaineSans-SemiBold.ttf') format('ttf');
}

:root {
    --darkest: #074F57;
    /* --dark: #077187; */
    --dark: #138D76;
    --mid: #74A57F;
    --pale: #9ECE9A;
    --palest: #F7C548;
    --pale-alt: #E4C5AF;

    --orange: #E7B673;
    --orange-pale: #F4D6B2;
    --purple: #5B213D;
    --green: #588C37;
    --background: #E4C5AF;
    --white: rgb(238, 238, 238);
    --black: rgb(10, 10, 10);
    --modal-back: rgb(238, 238, 238);
}

html,
body,
#app {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    z-index: 94;
    background-color: var(--white);
}

#app {
    font-family: 'ElaineSans', sans-serif;
    font-size: 21px;
    line-height: 1.5;
    letter-spacing: -0.007em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--darkest);
    overflow-x: hidden;
}

#app a,
#app a:visited {
    color: var(--darkest);
}

#app a:hover,
#app a:focus {
    color: var(--dark);
}

h1 {
    font-size: 2.5em;
    line-height: 1.1;
}

h1, h2, h3 {
    font-family: 'Tauri', 'ElaineSans-Bold', sans-serif;
    color: var(--dark);
}

b,
em {
    font-family: 'ElaineSans-Bold', sans-serif;
}

.center-wrapper {
    height: 100vh;
    padding: 0 1em;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ----- About Pages ----------------------------------------------------- */
.about-background {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 0;
    background-color: var(--mid);
    background-image: url(/images/greenham-home-kh.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-blend-mode: soft-light;
    opacity: .16;
    pointer-events: none;
}

.about-page {
    min-height: calc(100vh - 5em);
    padding-bottom: 5em;
    color: var(--darkest);
}

.about-info {
    z-index: 5;
    padding: 2em .5em 0;
}

.nav-info {
    display: none;
}

.gate-2d-page {
    /* max-width: 32em; */
    margin: 0 auto;
    padding: 2em .5em 6em;
}

@media screen and (min-width: 660px) {
    .about-page {
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .about-page main {
        max-width: 32em;
    }

    .about-info {
        padding: 0;
    }
}

@media screen and (min-width: 1060px) {
    .nav-info {
        display: block;
    }

    .gate-2d-page {
        width: 50vw;
        margin: 0;
    }

    .gate-2d-page .main {
        max-width: 32em;
        margin: 0 auto;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

/* --- FORMS ------------------------------------------------------------ */

.form .form-group {
    padding-bottom: 1em;
}

.form label,
.form input,
.form textarea {
    display: block;
    width: 100%;
}

.form input,
.form textarea {
    padding: .5em .75em;
    width: 85vw;
}

.form textarea {
    padding: .75em .75em;
    height: 15em;
    resize: none;
}

.form button {
    font: inherit;
    background: none;
    color: var(--darkest);
    padding: 0;
    cursor: pointer;
    outline: inherit;
    padding: .5em;
    border: 1px solid var(--darkest);
    -webkit-transition: 0.15s;
    transition: 0.15s;
    background-color: var(--white);
}

.form button:hover,
.form button:focus {
    border: 1px solid var(--dark);
    background-color: var(--dark);
    color: var(--white);
}
@media screen and (min-width: 660px) {
    .form input,
    .form textarea {
        width: calc(100% - .75em)
    }
}

/* --- END FORMS -------------------------------------------------------- */
</style>
